import styled from "styled-components";
import { Button, Text } from "suomifi-ui-components";
import { useTranslation } from "react-i18next";

const KuvatContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
  margin-top: ${({ theme }) => theme.spacing.m};
  padding: ${({ theme }) => theme.spacing.m};
  background: ${({ theme }) => theme.colors.depthLight3};
  border-radius: ${({ theme }) => theme.radiuses.basic};
`;

const KuvaRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.m};
`;

const KuvaLabel = styled.span`
  font: ${({ theme }) => theme.typography.bodyTextSmall};
  color: ${({ theme }) => theme.colors.blackBase};
  flex: 1;
`;

interface Props {
  uid: string;
  dokumenttiEtupuoliFileName?: string;
  dokumenttiTakapuoliFileName?: string;
  selfieFileName?: string;
}

export default function DokumenttiKuvat({
  uid,
  dokumenttiEtupuoliFileName,
  dokumenttiTakapuoliFileName,
  selfieFileName,
}: Props) {
  const { t } = useTranslation("kayttajaKortti");

  async function downloadFile(filename: string) {
    try {
      const response = await fetch(
        `/api/users/${uid}/tiedostot/${encodeURIComponent(filename)}`,
      );
      if (!response.ok) throw new Error("Download failed");

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Failed to download file:", error);
    }
  }

  const hasFiles =
    dokumenttiEtupuoliFileName || dokumenttiTakapuoliFileName || selfieFileName;

  if (!hasFiles) return null;

  return (
    <KuvatContainer>
      <Text>{t("dokumentit.kuvat.otsikko")}</Text>
      {dokumenttiEtupuoliFileName && (
        <KuvaRow>
          <KuvaLabel>{t("dokumentit.kuvat.etukuva")}</KuvaLabel>
          <Button
            onClick={() => downloadFile(dokumenttiEtupuoliFileName)}
            variant="secondary"
          >
            {t("dokumentit.kuvat.lataa")}
          </Button>
        </KuvaRow>
      )}
      {dokumenttiTakapuoliFileName && (
        <KuvaRow>
          <KuvaLabel>{t("dokumentit.kuvat.takakuva")}</KuvaLabel>
          <Button
            onClick={() => downloadFile(dokumenttiTakapuoliFileName)}
            variant="secondary"
          >
            {t("dokumentit.kuvat.lataa")}
          </Button>
        </KuvaRow>
      )}
      {selfieFileName && (
        <KuvaRow>
          <KuvaLabel>{t("dokumentit.kuvat.selfie")}</KuvaLabel>
          <Button
            onClick={() => downloadFile(selfieFileName)}
            variant="secondary"
          >
            {t("dokumentit.kuvat.lataa")}
          </Button>
        </KuvaRow>
      )}
    </KuvatContainer>
  );
}
